import { observer } from 'mobx-react'
import React from 'react'
import PortalComponent from './PortalComponent'
import { useClonedComponent } from '../../hooks/use-cloned-component'
import { isStateTreeNode } from '@invisr/mobx-state-tree'
import inject from '../mobx-inject'

const VirtualPortalComponent = inject('store')(observer(function _VirtualComponent (props) {
  let { component, item, index } = props
  const isNode = isStateTreeNode(component)
  if (!isNode) {
    component = Array.from(props.store.components.values()).find(comp => comp.id === component.id)
  }
  const comp = useClonedComponent(component, item, index)

  return comp ? <PortalComponent component={comp} key={comp.id} index={index} item={item} /> : null
}))

export default VirtualPortalComponent
